import React from 'react';
import CurrentPlanSpend from '../../currentPlanSpend';
import {
  INITIAL_PLAN_DOWNLOAD_FILE_MONTHLY_OPPS,
  INITIAL_PLAN_DOWNLOAD_FILE_WEEKLY_OPPS,
  INITIAL_PLAN_MONTHLY_SPEND_OPPS,
  INITIAL_PLAN_WEEKLY_HEADERS_OPPS,
  INITIAL_PLAN_WEEKLY_SPEND_OPPS,
} from '../constants';

export const InitialPlanSpendOpps = () => {
  return (
    <CurrentPlanSpend
      WEEKLY_SPEND_COMPONENT={INITIAL_PLAN_WEEKLY_SPEND_OPPS}
      MONTHLY_SPEND_COMPONENT={INITIAL_PLAN_MONTHLY_SPEND_OPPS}
      WEEKLY_HEADERS_COMPONENT={INITIAL_PLAN_WEEKLY_HEADERS_OPPS}
      title="Initial Plan Spend Opps"
      DOWNLOAD_FILE_NAME_WEEKLY={INITIAL_PLAN_DOWNLOAD_FILE_WEEKLY_OPPS}
      DOWNLOAD_FILE_NAME_MONTHLY={INITIAL_PLAN_DOWNLOAD_FILE_MONTHLY_OPPS}
    />
  );
};
